import React from "react";
import "./Nav.css";
import {AiOutlineHome} from "react-icons/ai";
import {AiOutlineUser} from "react-icons/ai";
import {BiMessage} from "react-icons/bi";
import {BiLibrary} from "react-icons/bi";
import {SiCountingworkspro} from "react-icons/si";

import {useState} from "react";

const Nav = ()=>{

    const [activeNav, setActiveNav] = useState("#");

    return (
        <nav>
            <a href="#" onClick={()=>{setActiveNav("#")}} className={activeNav === "#" ? "active" : ""} ><AiOutlineHome /></a>

            <a href="#about" onClick={()=>{setActiveNav("#about")}} className = {activeNav === "#about" ? "active" : ""} ><AiOutlineUser /></a>

            <a href="#skills" onClick={()=>{setActiveNav("#skills")}} className = {activeNav === "#skills" ? "active" : ""} ><BiLibrary /></a>

            <a href="#projects" onClick={()=>{setActiveNav("#projects")}} className = {activeNav === "#projects" ? "active" : ""} ><SiCountingworkspro /></a>

            <a href="#contact" onClick={()=>{setActiveNav("#contact")}} className = {activeNav === "#contact" ? "active" : ""} ><BiMessage /></a>     
        </nav>
    );
};

export default Nav;